import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Display the serial number for a sensor.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmId = (classes, props = {}) => {
  const { nick, name, serial } = props

  return (
    <Text
      color={'black'}
      variant={'14/bold'}
      className={classes.row}
    >
      {nick || name || serial || '-'}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmId)
